<template>
    <footer>
        <p>
            @2020&nbsp;广州易指网络科技有限公司<br>

            <!-- 网络游戏管理暂行办法&nbsp;&nbsp;游戏资质信息&nbsp;&nbsp;
            <a href="//www.miitbeian.gov.cn/"
               target="_blank"
               rel="nofollow">沪ICP备16020667号-1</a>&nbsp;&nbsp;
            <a href="//sq.ccm.gov.cn:80/ccnt/sczr/service/business/emark/toDetail/49D744063F4F5F61E0530140A8C0F82C"
               target="_blank"
               rel="nofollow">沪网文〔2017〕1877-075号</a>
            增值电信业务经营许可证沪B2-20180008
        </p> -->
        <!-- <p>雷电云手机 版权所有 QQ群：1081322573</p> -->
        <p>雷电云手机 版权所有</p>
    </footer>
</template>

<script>
export default {
    name: 'FooterNav'
}
</script>

<style lang='scss' scoped>
footer {
    width: 100%;
    // min-width: 1200px;
    // height: changeVw(100);
    background: #f5f5f5;
    margin: 0 auto;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: changeVw(28) 0;
    font-size: changeVw(12);
    color: #b3b3b3;
    p {
        text-align: center;
        line-height: 15px;
        a {
            color: #b3b3b3;
        }
    }
}
</style>
